import theme from 'config/theme';

export const BUTTON_CONSTANTS = {
  ICON_SIZE: 20,
  BUTTON_MIN_SIZE: 36,
  ICON_COLOR: theme.colors.neutral.$white,
  BORDER_OPACITY: 0.1,
} as const;
